<!-- eslint-disable vue/valid-v-for -->
<!-- eslint-disable vue/no-template-key -->
<script>
import ActionsMenu from '@/components(new)/UI/Tables/ActionsMenu/ActionsMenu.vue'
export default {
  components: {
    ActionsMenu
  },
  emits: ['onAction'],
  props: {
    title: String,
    stripe: Boolean,
    columns: {
      type: Array,
      validator: (value) => {
        return value.every((column) => column.key)
      }
    },
    tableData: {
      type: Array,
      default: () => []
    },
    onlyView: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<template>
  <div class="sedap-practices-table">
    <h3 class="sedap-practices-table__title">{{ title }}</h3>
    <el-table
      :data="tableData"
      :stripe="stripe"
    >
      <template v-for="column in columns">
        <el-table-column
          :prop="column.key"
          :label="column.label"
          :width="column.width"
          :align="column.align"
          v-if="column.key === 'legend'"
        >
          <template slot-scope="scope">
            <span class="sedap-practices-table__legend" :style="{ backgroundColor: scope.row.legend }" />
          </template>
        </el-table-column>
        <el-table-column
          :prop="column.key"
          :label="column.label"
          :width="column.width"
          :align="column.align"
          v-else-if="column.key === 'actions' && !onlyView"
        >
        <template slot-scope="scope">
          <el-button
            class="sedap-practices-table__actions"
            size="mini"
            @click="$emit('onAction', tableData[scope.$index])"
            :type="scope.row.actions.type"
            :disabled="scope.row.actions.disabled"
          >
            <font-awesome-icon :icon="scope.row.actions.icon" />
          </el-button>
          </template>
        </el-table-column>
        <el-table-column
          :prop="column.key"
          :label="column.label"
          :width="column.width"
          :align="column.align"
          v-else-if="column.key !== 'actions'"
        />
      </template>
    </el-table>
  </div>
</template>

<style lang="scss">
@import './styles.scss';
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Tables/PracticesTable/PracticesTable.vue